import React, { useState, useEffect } from 'react';
import SearchBar from '../_components/SearchBar';
import RecordsPerPageSelection from '../_components/RecordsPerPageSelection';
import { Pagination, Icon, Table, Popup, Label, TableCell } from 'semantic-ui-react';
import { alertService, userService } from '../_services';
import { Link } from 'react-router-dom';
import { formatPhoneNumbers } from '../_helpers/formatter';
import { statusIcons, statusLabels } from '../models/Constants';

export function List(props) {
    const { path } = props.match;
    const [contacts, setContacts] = useState({'data': []});
    const [pageParams, setPageParams] = useState({
            name: "",
            record_per_page: sessionStorage.getItem('record_per_page'),
            page_number: '0'
        });
    const [sortState, setSorting] = useState({
            column: null,
            data: null,
            direction: null
    });
    const { column, data, direction } = sortState

    const handleSort = (event) => {
        if (column !== event.column) {
            setSorting({
                column: event.column,
                data: _.sortBy(event.data, [event.column]),
                direction: "ascending"
            });
            console.log(event.data);
            setContacts({
                data: _.sortBy(event.data.data, [event.column]),
                record_per_page: contacts.record_per_page,
                page_number: contacts.page_number,
                status_code: contacts.status_code,
                total: contacts.total
            });
            return;
        }
        setSorting({
            column: event.column,
            data: contacts.data.reverse(),
            direction: direction === "ascending" ? "descending" : "ascending"
        });
    };

    const handleSearch = (searchValue) => {
        userService.getESUserByRole(searchValue)
        .then(setContacts)
        .catch( (error) => {   
            alertService.error(error);
        });
    }

    const handlePagination = (page) => {
        userService.getDesignatedContacts({
            name: pageParams.name,
            record_per_page: pageParams.record_per_page,
            page_number: Math.ceil(page),
        }).then( resp => {
            setContacts(resp);
        }).catch((error) => {
            if(err == "Unauthorized: 'Invalid Token.'."){
                history.push('/logout');
            }else{
                setContacts({'data': []});
                alertService.error(error);
            }
        });
    }

    const handleRecordsPerPage = (e, data) => {
        setPageParams({
            name: pageParams.name,  
            record_per_page: data.value, 
            page_number: pageParams.page_number
        });
    };

    useEffect(() => {
        handlePagination(pageParams.page_number);
    }, [pageParams.record_per_page]);

    return (
        <div>
            <div className="mt-2 pt-2">
                <div className="ui two column grid" width="100%">
                    <div className="fourteen wide column column-addon">
                        <SearchBar handleSearch={handleSearch} placeholderText='Enter a name'/>
                    </div>
                    <div className="two wide column column-addon">
                        <RecordsPerPageSelection handleSelection={ handleRecordsPerPage } />
                    </div>
                </div>
                <Table striped sortable>
                    <Table.Header>
                        <Table.HeaderCell
                            sorted={column == 'first_name' ? direction : null}
                            onClick={() => handleSort({ type: 'CHANGE_SORT', column: 'first_name', data: contacts})}
                        >
                            Contact Name
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            sorted={column == 'email' ? direction : null}
                            onClick={() => handleSort({ type: 'CHANGE_SORT', column: 'email', data: contacts})}
                        >
                            Email Address
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            sorted={column == 'facilities' ? direction : null}
                            onClick={() => handleSort({ type: 'CHANGE_SORT', column: 'facilities', data: contacts})}
                            width={4}
                        >
                            Facilities
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            sorted={column == 'providers' ? direction : null}
                            onClick={() => handleSort({ type: 'CHANGE_SORT', column: 'providers', data: contacts})}
                            width={4}
                        >
                            Providers
                        </Table.HeaderCell>
                        <Table.HeaderCell
                            sorted={column == 'phone_number' ? direction : null}
                            onClick={() => handleSort({ type: 'CHANGE_SORT', column: 'phone_number', data: contacts})}
                        >
                            Phone Number
                        </Table.HeaderCell>
                        <Table.HeaderCell
                        sorted={column == 'status' ? direction : null}
                        onClick={() => handleSort({ type: 'CHANGE_SORT', column: 'status', data: contacts})}
                        >
                            Locked Status
                        </Table.HeaderCell>
                    </Table.Header>
                    <Table.Body>
                        {contacts && contacts.data.map(contact =>
                            <Table.Row key={contact.user_id}>
                                <Table.Cell selectable style={{display:'flex', alignItems:'center', valign:'middle', verticalAlign:"middle"}}>
                                    <Popup content={statusLabels[contact.status]} trigger={statusIcons[contact.status]}></Popup>
                                    <Link to={`${path}/view/${contact.id}`}>{contact.first_name+" "+contact.last_name}</Link>
                                </Table.Cell>
                                <Table.Cell>{contact.email}</Table.Cell>
                                <Table.Cell >{contact.facilities.map((facility, index)  => <Label basic key = {index} style={{color:'#3F2A57',margin:'5px'}}>{facility}<Icon style={{paddingLeft:'10px'}}name='hospital outline' /></Label>)}</Table.Cell>
                                <Table.Cell >{contact.providers.map((provider, index) => <Label basic key = {index} style={{color:'#3F2A57',margin:'5px'}}>{provider}<Icon style={{paddingLeft:'10px'}}name='hospital outline' /></Label>)}</Table.Cell>
                                <Table.Cell>{contact.phone_number}</Table.Cell>
                                <Table.Cell textAlign='center'>{
                                    <Popup content={contact.locked? "Locked" : "Unlocked"} trigger={contact.locked? <Icon style={{paddingBottom: '19px'}}  name='lock closed' color='red'/>:<Icon style={{paddingBottom: '19px'}} name='lock open' color='green'/>}></Popup>    
                                }</Table.Cell>
                            </Table.Row>
                        )}
                        {!contacts &&
                            <Table.Row>
                                <Table.Cell colSpan="4" className="text-center">
                                    <div className="spinner-border spinner-border-lg align-center"></div>
                                </Table.Cell>
                            </Table.Row>
                        }
                        {contacts && !contacts.data.length &&
                            <Table.Row>
                                <Table.Cell colSpan="4" className="text-center">
                                    <div className="p-2">No ES Users To Display</div>
                                </Table.Cell>
                            </Table.Row>
                        }
                    </Table.Body>
                </Table>

                <div style={{display: 'flex',  justifyContent:'center', alignItems:'center'}}>
                    <Pagination className="mt-5 mb-5"
                        onPageChange={(event, data) => handlePagination(data.activePage-1)}
                        defaultActivePage={contacts ? contacts.page_number : 1}
                        ellipsisItem={{ content: <Icon name='ellipsis horizontal' />, icon: true }}
                        firstItem={{ content: <Icon name='angle double left' />, icon: true }}
                        lastItem={{ content: <Icon name='angle double right' />, icon: true }}
                        prevItem={{ content: <Icon name='angle left' />, icon: true }}
                        nextItem={{ content: <Icon name='angle right' />, icon: true }}
                        totalPages={contacts ? Math.ceil(contacts.total / contacts.record_per_page) : 0}
                    />
                </div>
            </div>
        </div>
    );
};